import { render } from "./VehicleListingsCustomPhrasesTrio.vue?vue&type=template&id=bf6219d0"
import script from "./VehicleListingsCustomPhrasesTrio.vue?vue&type=script&lang=js"
export * from "./VehicleListingsCustomPhrasesTrio.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/releases/343/listings.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__